import React, { FormEvent, useContext, useState } from 'react';
import { Btn } from '../common/Btn';
import { SearchContext } from '../../context/search.context';

export function Header() {
  const [inputVal, setInputVal] = useState('');
  const { setSearch } = useContext(SearchContext)

  function setSearchFromLocalState(e: FormEvent): void {
    e.preventDefault();
    setSearch(inputVal);
  }

  return (
    <>
      <header>

        <h1 className='header-item'><a href="/">Ogłoszenia aukcyjne</a></h1>
        <a href="/add-advert">
          <Btn name={'Dodaj ogłoszenie'} classes={['button']} bType={'submit'} />
        </a>

        <form className='header-item' onSubmit={setSearchFromLocalState}>
          <input className='search input mr-4' type="text" value={inputVal} onChange={e => setInputVal(e.target.value)} />
          <Btn name={'Szukaj'} classes={['button']} bType={'submit'} />
        </form>
      </header>
    </>
  );
}